export const APP_SET_TOKEN = 'APP_SET_TOKEN';
export const APP_SET_GROUP = 'APP_SET_GROUP';
export const APP_SET_SEASON = 'APP_SET_SEASON';
export const APP_SET_ORDER_FILTERS = 'APP_SET_ORDER_FILTERS';
export const APP_SET_ORDER_HIDDEN_COLUMNS = 'APP_SET_ORDER_HIDDEN_COLUMNS';
export const APP_SET_ORDER_SEARCH_FIELDS = 'APP_SET_ORDER_SEARCH_FIELDS';
export const APP_SET_ORDER_COLUMNS_WIDTH = 'APP_SET_ORDER_COLUMNS_WIDTH';
export const APP_SET_PARTICIPANT_HIDDEN_COLUMNS = 'APP_SET_PARTICIPANT_HIDDEN_COLUMNS';
export const APP_SET_PARTICIPANT_FILTERS = 'APP_SET_PARTICIPANT_FILTERS';
export const APP_SET_PURCHASER_HIDDEN_COLUMNS = 'APP_SET_PURCHASER_HIDDEN_COLUMNS';
export const APP_SET_PURCHASER_FILTERS = 'APP_SET_PURCHASER_FILTERS';
export const APP_SET_ORDER = 'APP_SET_ORDER';
export const APP_UPDATE_ORDER = 'APP_UPDATE_ORDER';
export const APP_DELETE_ORDER = 'APP_DELETE_ORDER';
export const APP_SET_MODULE = 'APP_SET_MODULE';
export const APP_ALLOW_AUTO_ORDER_UPDATE = 'APP_ALLOW_AUTO_ORDER_UPDATE';
export const APP_SET_EMPLOYEE_ID = 'APP_SET_EMPLOYEE_ID';
export const APP_SET_EMPLOYEE_CONFIG_ID = 'APP_SET_EMPLOYEE_CONFIG_ID';
export const APP_SET_ORDER_COLUMNS_SEQUENCE = 'APP_SET_ORDER_COLUMNS_SEQUENCE';
export const APP_SET_USER_EMAIL = 'APP_SET_USER_EMAIL';
export const REACT_APP_VERSION = 'REACT_APP_VERSION';

export const setReactAppVersion = version => ({
  type: REACT_APP_VERSION,
  payload: version
});

export const setToken = token => ({
  type: APP_SET_TOKEN,
  payload: token
});

export const setGroup = group => ({
  type: APP_SET_GROUP,
  payload: group
});

export const setSeason = season => ({
  type: APP_SET_SEASON,
  payload: season
});

export const setOrderFilters = orderFilters => ({
  type: APP_SET_ORDER_FILTERS,
  payload: orderFilters
});

export const setOrderHiddenColumns = orderHiddenColumns => ({
  type: APP_SET_ORDER_HIDDEN_COLUMNS,
  payload: orderHiddenColumns
});

export const setOrderSearchFields = orderSearchFields => ({
  type: APP_SET_ORDER_SEARCH_FIELDS,
  payload: orderSearchFields
});

export const setParticipantFilters = participantFilters => ({
  type: APP_SET_PARTICIPANT_FILTERS,
  payload: participantFilters
});

export const setParticipantHiddenColumns = participantHiddenColumns => ({
  type: APP_SET_PARTICIPANT_HIDDEN_COLUMNS,
  payload: participantHiddenColumns
});

export const setPurchaserFilters = purchaserFilters => ({
  type: APP_SET_PURCHASER_FILTERS,
  payload: purchaserFilters
});

export const setPurchaserHiddenColumns = purchaserHiddenColumns => ({
  type: APP_SET_PURCHASER_HIDDEN_COLUMNS,
  payload: purchaserHiddenColumns
});

export const setOrder = order => ({
  type: APP_SET_ORDER,
  payload: order
});

export const updateOrder = order => ({
  type: APP_UPDATE_ORDER,
  payload: order
});

export const deleteOrder = orderId => ({
  type: APP_DELETE_ORDER,
  payload: orderId
});

export const setModule = module => ({
  type: APP_SET_MODULE,
  payload: module
});

export const setAllowAutoOrderUpdate = value => ({
  type: APP_ALLOW_AUTO_ORDER_UPDATE,
  payload: value
});

export const setEmployeeId = employeeId => ({
  type: APP_SET_EMPLOYEE_ID,
  payload: employeeId
});

export const setEmployeeConfigId = employeeConfigId => ({
  type: APP_SET_EMPLOYEE_CONFIG_ID,
  payload: employeeConfigId
});


export const setOrderColumnsWidth = orderColumnsWidth => ({
  type: APP_SET_ORDER_COLUMNS_WIDTH,
  payload: orderColumnsWidth
});

export const setOrderColumnsSequence = orderColumnsSequence => ({
  type: APP_SET_ORDER_COLUMNS_SEQUENCE,
  payload: orderColumnsSequence
});

export const setUserEmail = email => ({
  type: APP_SET_USER_EMAIL,
  payload: email
});
